import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { Drawer } from "antd";

import ProfileDropdownContainer from "./navdropdown/profiledropdowncontainer";
import NotificationDropdownContainer from "./notifidropdown/notificationdropdowncontainer";
import DefaultItems from "./sidebar/defaultitems";

import UpgradeButton from "./upgrade/upgradebutton";
import SearchField from "./searchfield";

import useScreenSize from "../../../utils/usescreensize";
import images from "../../../assets";

const NavHeader = (props) => {
  const navigate = useNavigate();

  const location = useLocation();
  const screenSize = useScreenSize();

  const subscriptionData = useSelector((state) => state.subscription?.plan);

  const [open, setOpen] = useState(false);

  useEffect(() => {
    onClose();
  }, [location]);

  useEffect(() => {
    if (screenSize.width > 1024) {
      onClose();
    }
  }, [screenSize.width]);

  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  return (
    <div className="header">
      <div className="lg:hidden">
        <div
          onClick={showDrawer}
          className="p-2 rounded-md border border-n20 bg-n10 cursor-pointer"
        >
          <img src={images.hamburger} alt="hamburger" />
        </div>
        <Drawer
          rootClassName="navheader-drawer"
          closable={false}
          placement="left"
          onClose={onClose}
          open={open}
        >
          <DefaultItems onClick={onClose} />
        </Drawer>
      </div>

      <SearchField promotionheader={props?.promotionheader} />

      <div className="header-notification hidden lg:flex">
        <NotificationDropdownContainer
          promotionheader={props?.promotionheader}
        />
      </div>

      <div className="upgrade-profile-area hidden lg:flex">
        {!subscriptionData?.name ? (
          <UpgradeButton
            onClick={() => navigate("/membership-plan")}
            className="upgrade"
            title="Upgrade"
            disscunt="20% OFF"
          />
        ) : subscriptionData?.name !== "platinum" ? (
          <UpgradeButton
            onClick={() => navigate("/membership-plan")}
            className="premium"
            title="Premium"
          />
        ) : null}
      </div>

      <ProfileDropdownContainer promotionheader={props?.promotionheader} />
    </div>
  );
};

export default NavHeader;
